<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6">
<p class="noindent5">Gabriele Esposito is a military historian who works as a freelance author and researcher for some of the most important publishing houses in the military history sector. In particular, he is an expert specializing in uniformology: his interests and expertise range from the ancient civilizations to modern post-colonial conflicts. During recent years he has conducted and published several researches on the military history of the Latin American countries, with special attention on the War of the Triple Alliance and the War of the Pacific. He is among the leading experts on the military history of the Italian Wars of Unification and the Spanish Carlist Wars. His books and essays are published on a regular basis by Osprey Publishing, Winged Hussar Publishing and Libreria Editrice Goriziana; he is also the author of numerous military history articles appearing in specialized magazines like <em class="italic">Ancient Warfare Magazine</em>, <em class="italic">Medieval Warfare Magazine</em>, <em class="italic">The Armourer</em>, <em class="italic">History of War</em>, <em class="italic">Guerres et Histoire</em>, <em class="italic">Focus Storia</em> and <em class="italic">Focus Storia Wars</em>.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_FM1.vue?9553b1d0